import { createContext, useContext } from 'react';

export interface IModalContext {
  isOpen: boolean;
  links: string[];
  close: () => void;
  openSupportingLinks: (links: string[]) => void;
}

export const initialModalContext: IModalContext = {
  isOpen: false,
  links: [],
  openSupportingLinks: () => {},
  close: () => {},
};

export const ModalContext = createContext<IModalContext>(initialModalContext);

export const useModal = () => {
  const modal = useContext(ModalContext);

  return modal;
};
